// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"AccountMenu_icomoon-font__2kaai","AccountMenuHolder":"AccountMenu_AccountMenuHolder__29rjk","AccountMenuTitle":"AccountMenu_AccountMenuTitle__-3YB2"};